import { useRef, MutableRef } from 'preact/hooks';

import { Text } from '../UNSAFE_Text';

import { useNavigationListItem } from './useNavigationListItem';

export type NavigationListItemProps<K extends string | number> = {
  /**
   * Key of the NavigationListItem
   */
  itemKey: K;
  /**
   * Label of the NavigationListItem
   */
  label?: string;
};

/*TODO: JET-58535. Add ripple effect when touching navigationListItem. */
export function NavigationListItem<K extends string | number>({
  itemKey,
  label
}: NavigationListItemProps<K>) {
  const itemRef = useRef<HTMLLIElement | null>(null);

  //Logic of the component handled here
  const {
    isItemFocusable,
    itemHandlers,
    itemClasses,
    isSelected,
    labelContainerClasses,
    labelContainerStyle
  } = useNavigationListItem({
    itemRef: itemRef as MutableRef<HTMLLIElement>,
    itemKey
  });

  return (
    <li
      role="option"
      {...itemHandlers}
      data-oj-key={itemKey}
      class={itemClasses}
      tabIndex={isItemFocusable ? 0 : -1}
      aria-selected={isSelected}
      ref={itemRef}>
      {label && (
        <span class={labelContainerClasses} style={labelContainerStyle}>
          <Text size="inherit" weight="inherit" variant="inherit">
            {label}
          </Text>
        </span>
      )}
    </li>
  );
}
